import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import editFill from '@iconify/icons-ic/drag-handle';
import { Icon } from '@iconify/react';
import CryptoJS from 'crypto-js';
import React, { useCallback, useState } from 'react';
import { AiFillEdit, AiOutlineCheck, AiOutlineFileAdd } from 'react-icons/ai';
import { BiShareAlt, BiCloudDownload } from 'react-icons/bi';
import { BsCompass, BsFillReplyAllFill } from 'react-icons/bs';
import { FaFileInvoice, FaHandHoldingUsd, FaRegMoneyBillAlt } from 'react-icons/fa';
import { FiCheck, FiEye, FiFileText, FiX } from 'react-icons/fi';
import { GoFilePdf } from 'react-icons/go';
import {
  MdAppRegistration,
  MdUpdate,
  MdModeEdit,
  MdOutlineDateRange,
  MdPayments,
  MdPublishedWithChanges,
  MdReviews,
  MdDownload,
  MdGavel
} from 'react-icons/md';
import { RiFileCopyLine, RiFlowChart } from 'react-icons/ri';
import { TbCalculator } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
// material
import styled from '@emotion/styled';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import partnerService from '../../../pages/services/partnerService';
import { domainUrl } from '../../../pages/services/globalApi';
import useLoginSelector from '../../../store/Slice/Login/LoginSelector';
import { saveApiData } from '../../../store/Slice/Global/GlobalSlice';
import { OnboardingApi } from '../../../utils/Apis';

const { OnBoardReview } = partnerService;

export default function UserMoreMenu({
  partner,
  rowId,
  assignedTo,
  parent,
  setOpenStatus,
  UpdatePartnerStatusApi,
  partnerState,
  setOpenSendMsg,
  pageMenu,
  companyId,
  applicationId,
  recievableData,
  statusId,
  statusName,
  item,
  itemObj,
  bankId,
  bankName,
  setOpenPayment,
  setBranchEdit,
  setIndividualCommissionEdit,
  setVolumeCommissionEdit,
  setDeleteConfirm,
  itemBranchIndex,
  branchIndex,
  branchEditDialogOpen,
  branchDeleteDialogOpen,
  itemList,
  indexValue,
  individualEditDialogOpen,
  individualDeleteDialogOpen,
  itemListVolume,
  indexValueVolume,
  volumeEditDialogOpen,
  volumeDeleteDialogOpen,
  setEndAgreement,
  handlePublish,
  openEndAgreementDialog,
  aggrementIsActive,
  revenueId,
  leadId,
  handleCopyDialog,
  templateName,
  setSharePopUp,
  setDocumentPreview,
  docPrevHandler,
  statusCode,
  onPayClick,
  deleteUserRow,
  viewUserRow,
  handleRaiseAdvanceRequest,
  handlePaymentAction
}) {
  // console.log('sss usermenu--', partner, rowId);
  // console.log('sss pageMenu', pageMenu);
  const navigate = useNavigate();
  // console.log('rowId in usermoremenu', rowId);
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  // Styled icon button in Action
  const StyledIconButton = styled(IconButton)(() => ({
    backgroundColor: '#f0f9ff',
    color: '#0284c7',
    margin: '0 3px',
    padding: '6px',
    borderRadius: '8px',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#e0f2fe',
      color: '#0369a1'
    }
  }));

  async function fireUpdateStateApi(typeid) {
    const statusCredential = {
      companyId: LoginData?.companyId,
      partnerId: rowId,
      partnerStatusTypeId: typeid
    };
    const result = await dispatch(saveApiData(OnboardingApi?.onboardUpdate, statusCredential));
    if (result?.status === 'success') navigate('/partners/');
  }

  if (parent === 'leads') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', justifyContent: 'center' }}>
        <Tooltip title="Activity" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(19, 81, 157, 0.08)'
              }
            }}
            onClick={(e) => {
              const leadObj = {
                leadesItem: [itemObj]
              };
              localStorage.setItem('leadDetails', JSON.stringify(leadObj));
              navigate(`/${parent}/activity`, { state: leadObj });
            }}
          >
            <BsCompass size={18} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Process" placement="top" arrow>
          <span>
            <IconButton
              sx={{
                color: '#13519d',
                padding: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(19, 81, 157, 0.08)'
                },
                '&.Mui-disabled': {
                  color: '#cbd5e1'
                }
              }}
              disabled={applicationId !== null ? false : true}
              onClick={(e) => {
                const leadObj = {
                  leadesItem: [itemObj]
                };
                localStorage.setItem('leadDetails', JSON.stringify(leadObj));
                navigate(`/${parent}/process`, { state: leadObj });
              }}
            >
              <RiFlowChart size={18} />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  }
  if (parent === 'view-recommendation') {
    return (
      <>
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={() => {
              const obj = {
                recommendationId: rowId.partnerRecommendationId,
                applicationCreationEntryPlatform: rowId.applicationCreationEntryPlatform
              };
              localStorage.setItem('viewRecommendation', JSON.stringify(obj));
              // console.log('rowIdrowId', rowId);

              const apiCredentialsObj = {
                companyId: rowId?.loanType?.companyId
                  ? rowId?.loanType?.companyId
                  : LoginData?.companyId,
                employmentSubTypeId: {
                  employmentSubcategoryId: rowId?.empSubType?.employmentSubcategoryId,
                  companyId: rowId?.empSubType?.companyId
                    ? rowId?.empSubType?.companyId
                    : LoginData?.companyId,
                  employmentCategoryId: rowId?.empSubType?.employmentCategoryId,
                  employmentSubcategoryCode: rowId?.empSubType?.employmentSubcategoryCode,
                  employmentSubcategoryName: rowId?.empSubType?.employmentSubcategoryName,
                  employmentSubcategoryDescription:
                    rowId?.empSubType?.employmentSubcategoryDescription,
                  employmentSubcategoryIsActive: rowId?.empSubType?.employmentSubcategoryIsActive,
                  employmentSubcategoryDefaultLogo:
                    rowId?.empSubType?.employmentSubcategoryDefaultLogo,
                  employmentSubcategoryCustomLogo:
                    rowId?.empSubType?.employmentSubcategoryCustomLogo,
                  employmentSubcategoryDefaultSeq:
                    rowId?.empSubType?.employmentSubcategoryDefaultSeq,
                  employmentSubcategoryCustomSeq: rowId?.empSubType?.employmentSubcategoryCustomSeq
                },
                employmentTypeId: {
                  employmentCategoryId: rowId?.empType?.employmentCategoryId,
                  companyId: rowId?.empType?.companyId
                    ? rowId?.empType?.companyId
                    : LoginData?.companyId,
                  employmentCategoryCode: rowId?.empType?.employmentCategoryCode,
                  employmentCategoryName: rowId?.empType?.employmentCategoryName,
                  employmentCategoryDescription: rowId?.empType?.employmentCategoryDescription,
                  employmentCategoryDefaultLogo: rowId?.empType?.employmentCategoryDefaultLogo,
                  employmentCategoryCustomLogo: rowId?.empType?.employmentCategoryCustomLogo,
                  employmentCategoryDefaultSeq: rowId?.empType?.employmentCategoryDefaultSeq,
                  employmentCategoryCustomSeq: rowId?.empType?.employmentCategoryCustomSeq,
                  employmentCategoryIsActive: rowId?.empType?.employmentCategoryIsActive
                },
                journeyId: rowId?.journeyId,
                loanSubTypeId: {
                  compId: rowId?.loanSubType?.compId
                    ? rowId?.loanSubType?.compId
                    : LoginData?.companyId,
                  parentLoanId: rowId?.loanSubType?.parentLoanId,
                  loanId: rowId?.loanSubType?.loanId,
                  loanCode: rowId?.loanSubType?.loanCode,
                  loanName: rowId?.loanSubType?.loanName,
                  loanNameToDisplay: rowId?.loanSubType?.loanNameToDisplay,
                  loanDescription: rowId?.loanSubType?.loanDescription,
                  iconPath: rowId?.loanSubType?.iconPath,
                  defaultIconPath: rowId?.loanSubType?.defaultIconPath,
                  isActive: rowId?.loanSubType?.isActive,
                  currentSequence: rowId?.loanSubType?.currentSequence,
                  defaultSequence: rowId?.loanSubType?.defaultSequence
                },
                loanTypeId: {
                  companyId: rowId?.loanType?.companyId
                    ? rowId?.loanType?.companyId
                    : LoginData?.companyId,
                  parentLoanId: rowId?.loanType?.parentLoanId,
                  loanCode: rowId?.loanType?.loanCode,
                  parentLoanName: rowId?.loanType?.parentLoanName,
                  parentLoanDescription: rowId?.loanType?.parentLoanDescription,
                  iconPath: rowId?.loanType?.iconPath,
                  defaultIconPath: rowId?.loanType?.defaultIconPath,
                  isActive: rowId?.loanType?.isActive,
                  currentSequence: rowId?.loanType?.currentSequence,
                  defaultSequence: rowId?.loanType?.defaultSequence
                },
                userId: LoginData?.userId,
                pageCode: LoginData.jwt
              };
              localStorage.setItem('apiCredentials', JSON.stringify(apiCredentialsObj));
              navigate(`${parent}`);
            }}
          >
            <FiEye size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Share" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => setSharePopUp(true)}
          >
            <BiShareAlt size={11} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }

  if (parent === 'print-download') {
    return (
      <Tooltip title="View" placement="top" arrow onClick={(e) => setDocumentPreview(true)}>
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={11} />
        </StyledIconButton>
      </Tooltip>
    );
  }

  if (parent === 'print-download-leads') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={() => {
          const imgDetailsObj = {};
          imgDetailsObj.src = rowId.path;
          imgDetailsObj.alt = rowId.documentName;
          imgDetailsObj.contentType = rowId.contentType;
          docPrevHandler('open', JSON.stringify(imgDetailsObj));
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={11} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'login') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', justifyContent: 'center' }}>
        <Tooltip
          title="Process"
          placement="top"
          arrow
          disabled={rowId.applicationId !== null ? false : true}
        >
          <span>
            <IconButton
              sx={{
                color: '#13519d',
                padding: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(19, 81, 157, 0.08)'
                }
              }}
              disabled={rowId.applicationId === null}
              onClick={(e) => {
                const leadObj = {
                  leadesItem: [rowId]
                };
                localStorage.setItem('leadDetails', JSON.stringify(leadObj));
                navigate(`/${parent}/process`, { state: leadObj });
              }}
            >
              <RiFlowChart size={18} />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  }
  if (parent === 'revenue') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View File" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => navigate(`/${parent}/view`)}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Generate Invoice" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => navigate(`/${parent}/invoice`)}
          >
            <FaFileInvoice size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'revenue-receipt') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
          onClick={() => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-receipt`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'revenue-approved') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
          onClick={() => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-approved`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'revenue-disbursed') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
          onClick={() => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-disbursed`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'payout') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View File" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              const payoutIdData = {
                applicationId: rowId?.applicationId,
                partnerId: rowId?.partnerId,
                partnerPayoutId: rowId?.partnerPayoutId
              };
              localStorage.setItem('payoutIdData', JSON.stringify(payoutIdData));
              navigate(`/${parent}/view`, {
                state: {
                  rowId: rowId
                }
              });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
        {handleRaiseAdvanceRequest && (
          <Tooltip
            title="Raise Advance Request"
            placement="top"
            arrow
            disabled={rowId?.payoutStatus === 'Mis Matched'}
          >
            <span>
              <IconButton
                disabled={rowId?.payoutStatus === 'Mis Matched'}
                sx={{
                  color: '#13519d',
                  backgroundColor: 'rgba(19, 81, 157, 0.08)',
                  borderRadius: '8px',
                  p: 0.75,
                  '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' },
                  '&.Mui-disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    color: 'rgba(0, 0, 0, 0.26)'
                  }
                }}
                onClick={() => handleRaiseAdvanceRequest(rowId)}
              >
                <FaHandHoldingUsd size={16} />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Stack>
    );
  }

  if (parent === 'network') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              navigate(`/payout/network-view`, {
                state: {
                  rowId: rowId
                }
              });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'advance-pending') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        {rowId?.approvalStatus === 'PENDING' &&
        (LoginData?.userType === 'ADMIN' || LoginData?.userType === 'EMPLOYEE') ? (
          <>
            <Tooltip title="Approve" placement="top" arrow>
              <IconButton
                sx={{
                  color: '#2e7d32',
                  backgroundColor: 'rgba(46, 125, 50, 0.08)',
                  borderRadius: '8px',
                  p: 0.75,
                  '&:hover': { backgroundColor: 'rgba(46, 125, 50, 0.16)' }
                }}
                onClick={() => statusCode(rowId, 'APPROVED')}
              >
                <FiCheck size={16} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Reject" placement="top" arrow>
              <IconButton
                sx={{
                  color: '#d32f2f',
                  backgroundColor: 'rgba(211, 47, 47, 0.08)',
                  borderRadius: '8px',
                  p: 0.75,
                  '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.16)' }
                }}
                onClick={() => statusCode(rowId, 'REJECTED')}
              >
                <FiX size={16} />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          'N.A.'
        )}
      </Stack>
    );
  }

  if (parent === 'call-center') {
    return (
      <Tooltip title="View" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            padding: '4px',
            '&:hover': {
              backgroundColor: 'rgba(19, 81, 157, 0.08)'
            }
          }}
          onClick={(e) => {
            localStorage.setItem('viewCallCenterId', rowId);
            navigate('/call-center/view', { state: { rowId } });
          }}
        >
          <FiEye size={18} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'on-boarding') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        {pageMenu.length > 0 &&
          pageMenu.map((pageElement, index) => (
            <React.Fragment key={index}>
              {pageElement.subPageCode === 'ADD_NEW' && pageElement.isEnable === true ? (
                <Tooltip title="Edit" placement="top" arrow>
                  <IconButton
                    sx={{
                      color: '#13519d',
                      backgroundColor: 'rgba(19, 81, 157, 0.08)',
                      borderRadius: '8px',
                      p: 0.75,
                      '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                    }}
                    onClick={() => {
                      localStorage.setItem('partnerId', rowId);
                      navigate(`/onboarding/edit/${rowId}`, {
                        state: {
                          rowId: partner,
                          parent: 'on-boarding'
                        }
                      });
                    }}
                  >
                    <MdModeEdit size={16} />
                  </IconButton>
                </Tooltip>
              ) : pageElement.subPageCode === 'REVIEW' && pageElement.isEnable === true ? (
                <Tooltip title="Review" placement="top" arrow>
                  <IconButton
                    sx={{
                      color: '#13519d',
                      backgroundColor: 'rgba(19, 81, 157, 0.08)',
                      borderRadius: '8px',
                      p: 0.75,
                      '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                    }}
                    onClick={() => {
                      localStorage.setItem('partnerId', rowId);
                      navigate(`/onboarding/review`, { state: { rowId: rowId } });
                    }}
                  >
                    <MdReviews size={16} />
                  </IconButton>
                </Tooltip>
              ) : pageElement.subPageCode === 'SET_COMMISION' && pageElement.isEnable === true ? (
                <>
                  <Tooltip title="Set Commission" placement="top" arrow>
                    <IconButton
                      sx={{
                        color: '#13519d',
                        backgroundColor: 'rgba(19, 81, 157, 0.08)',
                        borderRadius: '8px',
                        p: 0.75,
                        '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                      }}
                      onClick={() => {
                        localStorage.setItem('partnerId', rowId);
                        navigate(`/onboarding/set-commission`, { state: { rowId: partner } });
                      }}
                    >
                      <FaRegMoneyBillAlt size={16} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Hierarchy" placement="top" arrow>
                    <IconButton
                      sx={{
                        color: '#13519d',
                        backgroundColor: 'rgba(19, 81, 157, 0.08)',
                        borderRadius: '8px',
                        p: 0.75,
                        '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                      }}
                      onClick={() =>
                        navigate('/onboarding/hierarchy', { state: { partnerId: rowId } })
                      }
                    >
                      <RiFlowChart size={16} />
                    </IconButton>
                  </Tooltip>
                </>
              ) : pageElement.subPageCode === 'ACTIVATE' && pageElement.isEnable === true ? (
                <Tooltip title="Activate" placement="top" arrow>
                  <span>
                    <IconButton
                      disabled={
                        partnerState === null ||
                        partner?.partnerStatus?.typeName === 'Rejected' ||
                        partner?.partnerStatus?.typeName === 'Activated' ||
                        partner?.partnerStatus?.typeName === 'Inactive' ||
                        partner?.partnerStatus?.typeName === 'Incomplete'
                      }
                      sx={{
                        color: '#16a34a',
                        backgroundColor: 'rgba(22, 163, 74, 0.08)',
                        borderRadius: '8px',
                        p: 0.75,
                        '&:hover': { backgroundColor: 'rgba(22, 163, 74, 0.16)' },
                        '&.Mui-disabled': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          color: 'rgba(0, 0, 0, 0.26)'
                        }
                      }}
                      onClick={() => {
                        UpdatePartnerStatusApi(rowId, partner);
                      }}
                    >
                      <AiOutlineCheck size={16} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : null}
            </React.Fragment>
          ))}
      </Stack>
    );
  }
  if (parent === 'invoice') {
    return (
      <>
        &nbsp;
        <Box sx={{ display: 'flex' }}>
          {pageMenu.length > 0 &&
            pageMenu.map((pageElement, index) => (
              <>
                {pageElement.subPageCode === 'RAISE_INVOICE' && pageElement.isEnable === true ? (
                  <>
                    <Tooltip
                      title="Raise Invoice"
                      placement="top"
                      arrow
                      onClick={(e) => navigate(`/${parent}/raise-invoice`)}
                    >
                      <StyledIconButton className="squareIconButton actionButton">
                        <FaFileInvoice size={11} />
                      </StyledIconButton>
                    </Tooltip>
                    &nbsp;
                  </>
                ) : pageElement.subPageCode === 'PAYMENT' && pageElement.isEnable === true ? (
                  <Tooltip
                    title="Payment"
                    placement="top"
                    arrow
                    onClick={(e) => navigate(`/${parent}/payment-invoice`)}
                  >
                    <StyledIconButton className="squareIconButton actionButton">
                      <MdPayments size={11} />
                    </StyledIconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
                {}
              </>
            ))}
        </Box>
      </>
    );
  }
  if (parent === 'receivable-file') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View File" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              const receivableIdData = {
                revenueId: revenueId,
                leadId: leadId,
                applicationId: applicationId,
                recievableData: recievableData
              };
              localStorage.setItem('receivableIdData', JSON.stringify(receivableIdData));
              navigate(`/receivable/view-file`, {
                state: {
                  rowId: recievableData
                }
              });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'report-file') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              navigate(`/report/view`);
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'receivable-invoice') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip
          title="Receipt"
          placement="top"
          arrow
          disabled={statusCode === 'PAID' || statusCode?.toUpperCase() === 'RECEIVED'}
        >
          <span>
            <IconButton
              disabled={statusCode === 'PAID' || statusCode?.toUpperCase() === 'RECEIVED'}
              sx={{
                color: '#13519d',
                backgroundColor: 'rgba(19, 81, 157, 0.08)',
                borderRadius: '8px',
                p: 0.75,
                '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={onPayClick}
            >
              <MdPayments size={16} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Download" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={() => viewUserRow(rowId)}
          >
            <MdDownload size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'data') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={(e) => {
          navigate(`/${parent}/view`, {
            state: {
              rowId: rowId,
              record: partner
            }
          });
        }}
      >
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'receivable-multiple-file') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="Edit" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
          >
            <AiFillEdit size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'payable') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={() => navigate(`/payable/view`, { state: { rowId } })}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download" disabled={rowId?.partnerId === 0} placement="top" arrow>
          <span>
            <IconButton
              disabled={rowId?.partnerId === 0}
              sx={{
                color: '#13519d',
                backgroundColor: 'rgba(19, 81, 157, 0.08)',
                borderRadius: '8px',
                p: 0.75,
                '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={() => onPayClick && onPayClick(rowId?.paybleId)}
            >
              <BiCloudDownload size={16} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Pay" placement="top" arrow disabled={rowId?.payableStatus === 'PAID'}>
          <span>
            <IconButton
              disabled={rowId?.payableStatus === 'PAID'}
              sx={{
                color: '#16a34a',
                backgroundColor: 'rgba(22, 163, 74, 0.08)',
                borderRadius: '8px',
                p: 0.75,
                '&:hover': { backgroundColor: 'rgba(22, 163, 74, 0.16)' },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={() => {
                if (handlePaymentAction) {
                  handlePaymentAction();
                } else if (setOpenPayment) {
                  setOpenPayment(true);
                }
              }}
            >
              <MdPayments size={16} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'prospect') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={(e) => {
          localStorage.setItem('prospectLeadId', rowId);
          navigate(`/${parent}/view`);
        }}
      >
        <IconButton sx={{ color: '#13519d', padding: '4px' }}>
          <FiEye size={18} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'master') {
    return (
      <>
        <Tooltip title="Delete" placement="top" arrow>
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="View" placement="top" arrow onClick={(e) => navigate(`/${parent}/add`)}>
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={11} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'agreement') {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Tooltip title="View & Edit" placement="top" arrow>
          <IconButton
            size="small"
            sx={{
              bgcolor: 'rgba(19, 81, 157, 0.08)',
              color: '#13519d',
              borderRadius: '8px',
              p: 0.8,
              '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              localStorage.setItem('viewAgreementId', rowId);
              localStorage.removeItem('reviewData');
              localStorage.removeItem('commisssionType');
              navigate(`/${parent}/view`, {
                state: {
                  rowId: rowId,
                  record: partner
                }
              });
            }}
          >
            <FiEye size={14} />
          </IconButton>
        </Tooltip>
        <Tooltip title="End Agreement" placement="top" arrow>
          <span>
            <IconButton
              size="small"
              disabled={aggrementIsActive === null || aggrementIsActive === true ? false : true}
              sx={{
                bgcolor: 'rgba(239, 68, 68, 0.08)',
                color: '#ef4444',
                borderRadius: '8px',
                p: 0.8,
                '&:hover': { bgcolor: 'rgba(239, 68, 68, 0.16)' },
                '&.Mui-disabled': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={(e) => {
                openEndAgreementDialog(e, rowId);
              }}
            >
              <MdOutlineDateRange size={14} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'add-branch-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          // onClick={(e) => {
          //   setBranchEdit(true);
          // }}
          onClick={(e) => branchEditDialogOpen(e, itemBranchIndex, branchIndex)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            branchDeleteDialogOpen(e, itemBranchIndex, branchIndex);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'individual-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          // onClick={(e) => setIndividualCommissionEdit(true)}
          onClick={(e) => individualEditDialogOpen(e, itemList, indexValue)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            individualDeleteDialogOpen(e, itemList, indexValue);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'volume-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            // setVolumeCommissionEdit(true);
            volumeEditDialogOpen(e, itemListVolume, indexValueVolume);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            volumeDeleteDialogOpen(e, itemListVolume, indexValueVolume);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'policy') {
    return (
      <>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('aggrementPolicyId', rowId);
            // localStorage.setItem('viewPolicyAgreementId', viewPolicyAgreementId);
            navigate(`/${parent}/view-policy`, {
              state: {
                rowData: partner
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('aggrementPolicyId', rowId);
            // localStorage.setItem('viewPolicyAgreementId', viewPolicyAgreementId);
            navigate(`/${parent}/edit-policy`, {
              state: {
                rowData: partner,
                rowId: rowId,
                pageType: 'Edit'
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={11} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'journey') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('viewJourneyId', rowId.journeyId);
            localStorage.removeItem('cardTypeListAll');
            localStorage.removeItem('journeyDetailsId');
            localStorage.removeItem('fldListAll');
            localStorage.removeItem('journeybyIdData');
            navigate(`/${parent}/add`, {
              state: {
                rowData: rowId,
                pageType: 'Edit'
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          disabled={rowId.journeyPublished === 'YES' ? true : false}
          title="Publish"
          placement="top"
          arrow
          onClick={() => handlePublish('Publish', rowId.journeyId)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <MdPublishedWithChanges size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          disabled={rowId.journeyPublished === 'YES' ? true : false}
          title="Delete"
          placement="top"
          arrow
          onClick={() => handlePublish('Delete', rowId.journeyId)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('viewJourneyId', rowId.journeyId);
            localStorage.removeItem('cardTypeListAll');
            localStorage.removeItem('journeyDetailsId');
            localStorage.removeItem('fldListAll');
            localStorage.removeItem('journeybyIdData');
            navigate(`/${parent}/view`, {
              state: {
                rowData: rowId
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={11} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'journey-template') {
    return (
      <>
        <Tooltip
          title="Copy"
          placement="top"
          arrow
          onClick={(e) => {
            handleCopyDialog(e, rowId, templateName);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <RiFileCopyLine size={11} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('journeyTemplateId', rowId);
            navigate(`/journey/viewTemplate`);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={11} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  // if (parent === 'payable') {
  //   return (
  //     <Box sx={{ display: 'flex' }}>
  //       <Tooltip title="Invoice as Pdf" placement="top" arrow>
  //         <StyledIconButton className="squareIconButton actionButton">
  //           <GoFilePdf size={11} />
  //         </StyledIconButton>
  //       </Tooltip>
  //       <Tooltip title="View" placement="top" arrow>
  //         <StyledIconButton
  //           className="squareIconButton actionButton"
  //           onClick={(e) => navigate(`/payable`)}
  //         >
  //           <FiEye size={11} />
  //         </StyledIconButton>
  //       </Tooltip>
  //       <Tooltip title="Pay" placement="top" arrow>
  //         <StyledIconButton
  //           className="squareIconButton actionButton"
  //           onClick={(e) => navigate(`/payable`)}
  //         >
  //           <MdPayments size={11} />
  //         </StyledIconButton>
  //       </Tooltip>
  //     </Box>
  //   );
  // }
  if (parent === 'users') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            size="small"
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={() => viewUserRow({ userId: rowId, action: 'view' })}
          >
            <FiEye size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit" placement="top" arrow>
          <IconButton
            size="small"
            sx={{
              color: '#0284c7',
              backgroundColor: 'rgba(2, 132, 199, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(2, 132, 199, 0.16)' }
            }}
            onClick={() => viewUserRow({ userId: rowId, action: 'edit' })}
          >
            <MdModeEdit size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Set Incentive" placement="top" arrow>
          <IconButton
            size="small"
            sx={{
              color: '#16a34a',
              backgroundColor: 'rgba(22, 163, 74, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(22, 163, 74, 0.16)' }
            }}
            onClick={(e) => {
              localStorage.setItem('partnerId', rowId);
              navigate(`/users/set-incentive-for-employeePartner`, { state: { rowId: rowId } });
            }}
          >
            <FaRegMoneyBillAlt size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" placement="top" arrow>
          <IconButton
            size="small"
            sx={{
              color: '#ef4444',
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.16)' }
            }}
            onClick={() => deleteUserRow(rowId)}
          >
            <Icon icon={trash2Outline} width={15} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'customer') {
    return (
      <Tooltip title="View" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
          onClick={(e) => {
            navigate(`/${parent}/view`, { state: rowId });
          }}
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }
  if (parent === 'partner') {
    return (
      <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={(e) => {
              localStorage.setItem('partnerId', rowId);
              navigate(`/partners/view/${rowId}`, {
                state: {
                  rowId: partner,
                  parent: 'partner'
                }
              });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'bankops') {
    const isDecisionEnabled =
      rowId.logInStatusName === 'Sanctioned' || rowId.logInStatusName === 'Rejected';

    return (
      <Stack direction="row" spacing={0.75} alignItems="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={() => {
              localStorage.setItem('selectedItem', JSON.stringify(rowId));
              navigate(`/${parent}/view`, { state: rowId });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Decision" placement="top" arrow>
          <span>
            <IconButton
              disabled={!isDecisionEnabled}
              sx={{
                color: '#13519d',
                backgroundColor: 'rgba(19, 81, 157, 0.08)',
                borderRadius: '8px',
                p: 0.75,
                '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={() => {
                if (isDecisionEnabled) {
                  localStorage.setItem('selectedItem', JSON.stringify(rowId));
                  navigate(`/${parent}/decision`, { state: rowId });
                }
              }}
            >
              <MdGavel size={16} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'disburse') {
    const isProcessEnabled =
      rowId?.status?.toLowerCase() === 'encashment' ||
      rowId?.status?.toLowerCase() === 'disburse approved' ||
      rowId?.status?.toLowerCase() === 'encashment approved';

    return (
      <Stack direction="row" spacing={0.75} alignItems="center">
        <Tooltip title="View" placement="top" arrow>
          <IconButton
            sx={{
              color: '#13519d',
              backgroundColor: 'rgba(19, 81, 157, 0.08)',
              borderRadius: '8px',
              p: 0.75,
              '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
            }}
            onClick={() => {
              localStorage.setItem('selectedItem', JSON.stringify(rowId));
              navigate(`/${parent}/view`, { state: rowId });
            }}
          >
            <FiEye size={16} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Approve Disbursement" placement="top" arrow>
          <span>
            <IconButton
              disabled={!isProcessEnabled}
              sx={{
                color: '#13519d',
                backgroundColor: 'rgba(19, 81, 157, 0.08)',
                borderRadius: '8px',
                p: 0.75,
                '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
              onClick={() => {
                if (isProcessEnabled) {
                  localStorage.setItem('selectedItem', JSON.stringify(rowId));
                  navigate(`/${parent}/process`, { state: rowId });
                }
              }}
            >
              <MdUpdate size={16} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'rejected') {
    return (
      <Tooltip title="View" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
          onClick={() =>
            navigate(`/${parent}/view`, {
              state: { rowId }
            })
          }
        >
          <FiEye size={16} />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" justifyContent="center">
      <Tooltip title="Delete" placement="top" arrow>
        <IconButton
          sx={{
            color: '#d32f2f',
            backgroundColor: 'rgba(211, 47, 47, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.16)' }
          }}
        >
          <Icon icon={trash2Outline} width={16} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit" placement="top" arrow>
        <IconButton
          sx={{
            color: '#13519d',
            backgroundColor: 'rgba(19, 81, 157, 0.08)',
            borderRadius: '8px',
            p: 0.75,
            '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
          }}
        >
          <Icon icon={editFill} width={16} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
